module.exports = __webpack_public_path__ + "img/carwash.3586bc09.jpg";